export default __webpack_public_path__ + "static/media/addBox.00b45180.svg";